import { NonIdealState } from '@blueprintjs/core';
import * as React from 'react';

const NotFound = () => <NonIdealState icon="unknown-vehicle" title="Page Not Found" />;

export default NotFound;
